import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

import type { DateFilterParams } from '@shared/types/common.types';
import { formatDateToDesiredFormat } from '@shared/utils/date/dateUtil';

interface FilterButtonComponentProps {
  filterValue: DateFilterParams;
  handleResetFilter: () => void;
  isDisableResetFilter: boolean;
  onToggleFilter: () => void;
}

const FilterButtonComponent = ({
  filterValue,
  handleResetFilter,
  isDisableResetFilter,
  onToggleFilter,
}: FilterButtonComponentProps) => {
  const { t } = useTranslation();

  return (
    <section className="flex w-full flex-col gap-y-2.5">
      <section>
        <Button
          className="mr-2 min-w-[100px] rounded-md border border-theme-700 bg-transparent text-xs font-semibold text-theme-700"
          onClick={onToggleFilter}
        >
          {t('labTestResults.filterBtn.filterBtnText')}
        </Button>
        <Button
          className={`min-w-[100px] rounded-md border bg-transparent px-2 text-xs font-semibold ${
            isDisableResetFilter ? 'cursor-not-allowed border-gray-300' : 'border-theme-700'
          }`}
          {...(!isDisableResetFilter && { onClick: handleResetFilter })}
        >
          <span className={`${isDisableResetFilter && 'text-gray-300'}`}>
            {t('labTestResults.filterBtn.resetFilterBtnText')}
          </span>
        </Button>
      </section>
      {!isDisableResetFilter && (
        <span className="mt-2.5 text-sm text-functional-iron">
          Filtered results: {formatDateToDesiredFormat(filterValue.FromDate)} -{' '}
          {formatDateToDesiredFormat(filterValue.ToDate)}
        </span>
      )}
    </section>
  );
};

export default FilterButtonComponent;
